import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c606574"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "l-wrapper" }
const _hoisted_2 = { class: "l-wrapper_main" }
const _hoisted_3 = { class: "p-login" }
const _hoisted_4 = { class: "p-login-inner" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-recommend-form__text-7" }, [
  /*#__PURE__*/_createTextVNode("メールアドレスの認証が"),
  /*#__PURE__*/_createElementVNode("span", { class: "sp-break" }, [
    /*#__PURE__*/_createElementVNode("br")
  ]),
  /*#__PURE__*/_createTextVNode("完了しました")
], -1))
const _hoisted_6 = { class: "p-recommend-form__text-8 u-mt-16 u-mb-16" }
const _hoisted_7 = { class: "p-login-text-block" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ページを閉じる", -1))
const _hoisted_10 = [
  _hoisted_9
]

import { ref } from 'vue';
import { domHelperUtils } from '@/utils/domHelper';


export default /*#__PURE__*/_defineComponent({
  __name: 'MailSecuritySuccessView',
  props: {
  email: {
    type: String,
    default: ''
  }
},
  setup(__props) {

const props = __props



// ウィンドウを閉じる関数を追加
function closeWindow() {
  window.close();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("main", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("p", _hoisted_6, _toDisplayString(props.email), 1),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("a", {
              class: "p-recommend-button --type-2 --width-set-1 t-decoration-none",
              href: "#",
              onClick: _withModifiers(closeWindow, ["prevent"])
            }, _hoisted_10, 8, _hoisted_8)
          ])
        ])
      ])
    ])
  ]))
}
}

})